// src/pages/Home.jsx
import React from "react";
import Section from "../components/Section";
import { Link } from "react-router-dom";
import Carousel from "./Carousel";

const Home = () => {
  return (
    <>
    <Carousel />
      <Section id="presentacion" title="Somos Contarte">
        <p>
          Somos una joven cooperativa de trabajo cultural, creada para la producción y gestión de eventos y hechos culturales, en toda la amplitud del término Cultura.
          Se propone agitar la rutina, descubrir nuevos intereses frecuentemente postergados, facilitar el acceso a un cambio de ruta y dedicar tiempo para sí, para lo que no se disfruta y no se sabe bien por qué.
        </p>
        <div className="link-grid">
        <Link className="link" to="/eventos">
            <h3 className="icon-text">Eventos</h3>
            <img src="/img/carousel.jpg" alt="Eventos" />
          </Link>
          <Link className="link" to="/cultura">
          <h3 className="icon-text">Cultura en la Casa</h3>
            <img src="/img/carousel2.jpg" alt="Cultura en la casa" />
          </Link>
          <Link className="link" to="/recomendaciones">
          <h3 className="icon-text">Recomendaciones</h3>
            <img src="/img/carousel3.jpg" alt="Recomendaciones" />
          </Link>
        </div>
      </Section>
    </>
  );
};

export default Home;
